export default function ConfettiLinear(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="2.4em"
      height="2.4em"
      {...props}
      style={{
        paddingRight: "0.5em",
        marginLeft: "0.5em",
      }}
    >
      <g fill="none">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="m4.012 15.762l1.69-5.069c.766-2.298 1.149-3.447 2.055-3.66c.906-.215 1.763.642 3.475 2.355l3.38 3.379c1.712 1.713 2.569 2.569 2.355 3.475s-1.363 1.29-3.661 2.055l-5.069 1.69c-2.765.922-4.148 1.383-4.878.653s-.269-2.113.653-4.878Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="M12.235 18.346s-.758-2.281-.758-3.79c0-1.51.758-3.792.758-3.792m-4.17 8.72s-.64-2.753-.758-4.55c-.195-2.969.758-7.581.758-7.581m6.445 2.653l.143-.72c.146-.727.67-1.32 1.373-1.554a2.07 2.07 0 0 0 1.372-1.555l.144-.72m.028 7.796l.212.123c.657.38 1.483.296 2.051-.207a1.76 1.76 0 0 1 1.876-.297L22 13M9.795 2.779A1.4 1.4 0 0 0 10 4.5l.097.098c.394.393.539.97.378 1.503"
        ></path>
        <path
          fill="currentColor"
          d="M6.928 3.94a.536.536 0 1 1 .758.76a.536.536 0 0 1-.758-.76m5.229 3.217a.536.536 0 1 1 .759.759a.536.536 0 0 1-.759-.759m5 3a.536.536 0 1 1 .759.759a.536.536 0 0 1-.759-.759m1.901 5.156a.536.536 0 1 1 .759.759a.536.536 0 0 1-.759-.759"
        ></path>
        <path
          stroke="currentColor"
          strokeLinejoin="round"
          d="M19.362 7.714c-.67.67-.19 2.614-.19 2.614s1.944.481 2.614-.19c.71-.71.308-1.64-.786-1.638c.003-1.094-.928-1.496-1.638-.786Z"
        ></path>
        <path
          stroke="currentColor"
          d="m15.188 3.417l-.027.098c-.03.106-.046.16-.039.212s.036.098.093.189l.053.082c.201.32.302.48.234.611c-.07.131-.262.146-.648.176l-.1.008c-.11.009-.164.013-.212.038s-.084.068-.155.155l-.065.079c-.25.304-.375.456-.518.437s-.21-.198-.341-.555l-.034-.092c-.038-.102-.056-.152-.093-.19c-.037-.036-.088-.055-.189-.092l-.092-.034c-.357-.132-.535-.198-.555-.34c-.02-.144.133-.27.437-.52l.079-.065c.086-.07.13-.106.155-.154s.03-.103.038-.213l.008-.1c.03-.385.045-.578.175-.647c.131-.069.291.032.611.234l.083.052c.09.058.136.086.189.093s.105-.008.212-.038l.097-.027c.376-.107.563-.16.664-.06c.1.1.047.288-.06.663Z"
        ></path>
      </g>
    </svg>
  );
}
